export default "__VITE_ASSET___6mdO57O__"